export type LockboxCredentialsState = "loading" | "error" | "ready";

export const lockboxCredentialsState = ({
  isLoading,
  isError
}: {
  isLoading: boolean;
  isError: boolean;
}): LockboxCredentialsState => {
  if (isLoading) return "loading";
  if (isError) return "error";
  return "ready";
};
